// Shared styling for the onboarding flow. Mirrors the app's design language:
// brand accent #FF1493 (primary.main), Catamaran display font, rounded cards, and the
// pink CTA button with the offset shadow used on the pricing cards.

export const ACCENT = '#FF1493'

export const onboardingStyles = {
    page: {
        minHeight: '100vh',
        backgroundColor: 'primary.bg',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        px: 2,
        py: { xs: 2, md: 4 },
        boxSizing: 'border-box',
        fontFamily: 'Catamaran',
    },
    progressWrap: {
        width: '100%',
        maxWidth: '520px',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        mb: 1.5,
    },
    progressTopRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: '40px',
    },
    backButton: {
        textTransform: 'none',
        fontFamily: 'Catamaran',
        fontWeight: 600,
        color: 'text.gray',
        minWidth: 'auto',
    },
    stepCount: {
        fontFamily: 'Catamaran',
        fontWeight: 700,
        color: 'text.gray',
        fontSize: '0.85rem',
    },
    progressBar: {
        height: 8,
        borderRadius: 999,
        backgroundColor: '#f0d7e6',
        '& .MuiLinearProgress-bar': {
            backgroundColor: ACCENT,
            borderRadius: 999,
        },
    },
    card: {
        width: '100%',
        maxWidth: '520px',
        borderRadius: '32px',
        p: { xs: '1.6rem', md: '2.2rem' },
        boxSizing: 'border-box',
    },
    title: {
        fontFamily: 'Catamaran',
        fontWeight: 900,
        fontSize: { xs: '1.6rem', md: '1.9rem' },
        lineHeight: 1.1,
        mb: 1,
    },
    subtitle: {
        fontFamily: 'Catamaran',
        fontWeight: 500,
        color: 'text.gray',
        fontSize: '0.98rem',
        mb: 2.5,
    },
    ctaButton: {
        m: '0.4rem 0',
        p: '0.8rem 2rem',
        fontFamily: 'Catamaran',
        fontWeight: 700,
        fontSize: '1rem',
        backgroundColor: 'primary.main',
        color: '#fff',
        textTransform: 'none',
        boxShadow: '4px 5px 0px #000',
        borderRadius: '40px',
        width: '100%',
        '&:hover': { backgroundColor: '#e01284', boxShadow: '4px 5px 0px #000' },
        '&.Mui-disabled': { backgroundColor: '#f4a8d3', color: '#fff', boxShadow: 'none' },
    },
    skipButton: {
        textTransform: 'none',
        fontFamily: 'Catamaran',
        fontWeight: 600,
        color: 'text.gray',
        width: '100%',
        mt: 0.5,
    },
    footer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: 2,
    },
}
